import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { CONFIG } from '../../../api/config'
import ButtonComponent from '../../../components/ui/button.component'
import { ConfirmModalComponent } from '../../../components/ui/modals/confirm.modal.component'
import useWindowWidth from '../../../utils/use.window.width'
import * as styled from './styled'

const slides = [
	{
		title: 'Вебпортал',
		number: '01',
		button: {
			text: 'Зареєструватися',
			href: CONFIG.SMART_CITY,
		},
		items: [
			'Онлайн-реєстрація звернень мешканців;',
			'Особистий кабінет мешканця;',
			'Повідомлення про планові або аварійні роботи в місті;',
			'Карта звернень від мешканців міста;',
			'Результати роботи комунальних служб міста по зверненням мешканців, загальна статистика за результатими робіт.',
		],
	},
	{
		title: 'Контакт-центр',
		number: '02',
		description:
			'Міська телефонна служба, яка допомагає мешканцям отримувати консультації, подавати звернення та оперативно вирішувати проблемні питання. Контакт-центр забезпечує контроль якості виконання звернень через постійний зворотний зв’язок із заявниками. Зателефонувати можна за номерами телефонів:',

		phones: [
			'15-80 (зі стаціонарних)',
			'(061) 787 15 80',
			'(050) 414 15 80',
			'(067) 656 15 80',
		],
	},
	{
		title: 'Через чат-бот',
		number: '03',
		button: {
			text: 'Telegram бот “Запоріжжя 1580”',
			href: 'https://t.me/colcentrebot',
		},
		items: [
			'Повідомлення про планові або аварійні роботи за вашими адресами;',
			'Довідкова інформація про контакти та режим роботи виконавчих органів, комунальних підприємств міської ради;',
			'Подача звернень мешканців;',
		],
	},
]

export const AppealMethodsComponent = () => {
	const windowWidth = useWindowWidth()
	const isTablet = windowWidth <= 768

	const [isConfirmOpen, setIsConfirmOpen] = useState(false)
	const [active, setActive] = useState(0)

	const handleButtonClick = (href: string) => {
		const isSmartCity = href === CONFIG.SMART_CITY
		const isSkipMode = localStorage.getItem('skipConfirmCabinet') === 'true'

		if (isSmartCity && !isSkipMode) {
			setIsConfirmOpen(true)
		} else {
			window.open(href, '_blank', 'noopener,noreferrer')
		}
	}

	return (
		<styled.AppealMethodsWrapper>
			<styled.AppealMethodsHeadline>
				<styled.AppealMethodsTitle>
					Обирайте зручний спосіб подачі звернення!
				</styled.AppealMethodsTitle>
				<styled.AppealMethodsText>
					Ми створили просту систему сервісів, щоб ваше звернення миттєво
					потрапило до виконавця. Подавайте заявку онлайн або телефоном — ми
					працюємо 24/7
				</styled.AppealMethodsText>
			</styled.AppealMethodsHeadline>
			<styled.AppealMethodsBody>
				<styled.Wrapper>
					<styled.Left>
						{slides.map((slide, index) => (
							<styled.MenuItem
								$active={index === active}
								key={index}
								onClick={() => setActive(index)}
							>
								{slide.title}
							</styled.MenuItem>
						))}
						{!isTablet && slides[active].button && (
							<ButtonComponent
								text={slides[active]!.button!.text}
								position='top-right'
								onClick={() => handleButtonClick(slides[active]!.button!.href)}
							/>
						)}
					</styled.Left>

					<styled.Right>
						{slides.map((slide, index) => (
							<styled.EmblaSlide key={index} $active={index === active}>
								<styled.Title>
									<styled.Number>{slide.number}</styled.Number>
									{slide.title}
								</styled.Title>
								{slide.items && (
									<styled.List>
										{slide.items.map((item, i) => (
											<li key={i}>{item}</li>
										))}
									</styled.List>
								)}
								{slide.description && (
									<styled.Description>{slide.description}</styled.Description>
								)}
								{slide.phones && (
									<styled.Phones>
										{slide.phones.map((phone, i) => (
											<li key={i}>{phone}</li>
										))}
									</styled.Phones>
								)}
								{isTablet && slides[active].button && (
									<styled.ButtonContainer>
										<ButtonComponent
											text={slides[active]!.button!.text}
											position='top-right'
											onClick={() =>
												handleButtonClick(slides[active]!.button!.href)
											}
										/>
									</styled.ButtonContainer>
								)}
							</styled.EmblaSlide>
						))}
					</styled.Right>
				</styled.Wrapper>
			</styled.AppealMethodsBody>
			<AnimatePresence>
				{isConfirmOpen && (
					<ConfirmModalComponent
						onClose={() => setIsConfirmOpen(false)}
						onBack={() => setIsConfirmOpen(false)}
					/>
				)}
			</AnimatePresence>
		</styled.AppealMethodsWrapper>
	)
}
